const translation = {
  title: 'สํารวจ',
  sidebar: {
    discovery: 'การค้นพบ',
    chat: 'สนทนา',
    workspace: 'พื้นที่',
    action: {
      pin: 'เข็มกลัด',
      unpin: 'ปลดหมุด',
      rename: 'ตั้งชื่อใหม่',
      delete: 'ลบ',
    },
    delete: {
      title: 'ลบแอป',
      content: 'คุณแน่ใจหรือไม่ว่าต้องการลบแอปนี้?',
    },
  },
  apps: {
    title: 'สํารวจแอพโดย Dify',
    description: 'ใช้แอปเทมเพลตเหล่านี้ทันทีหรือปรับแต่งแอปของคุณเองตามเทมเพลต',
    allCategories: 'แนะ นำ',
  },
  appCard: {
    addToWorkspace: 'เพิ่มไปยังพื้นที่ทํางาน',
    customize: 'ปรับแต่ง',
  },
  appCustomize: {
    title: 'สร้างแอปจาก {{name}}',
    subTitle: 'ไอคอนและชื่อแอป',
    nameRequired: 'ต้องใช้ชื่อแอป',
  },
  category: {
    Assistant: 'ผู้ช่วย',
    Writing: 'การเขียน',
    Translate: 'แปล',
    Programming: 'โปรแกรม',
    HR: 'ชั่วโมง',
    Workflow: 'เวิร์กโฟลว์',
    Agent: 'ตัวแทน',
    Entertainment: 'ความบันเทิง',
  },
}

export default translation
